import { canAccessResource } from '../../../authorization/canAccessResource';
import { globalpermissions } from '../../../Services/Permission.js';

/**
 * Whether the current user may create a new business service under an account.
 *
 * AuthZ v2: account-level edit grant on the business function.
 * Legacy: profile feature `can_create_new_proposal`.
 *
 * @param {import('../../../authorization/types/authz.types').AuthzContext|null|undefined} authz
 * @param {{ accountId?: string, userInfo?: object|null, legacyUserHasPermission?: (permissions: string[]) => boolean }} params
 */
export function canCreateWorkspace(authz, {
  accountId,
  userInfo,
  legacyUserHasPermission,
} = {}) {
  if (!accountId) {
    return false;
  }

  if (authz?.isFullAccess) {
    return true;
  }

  if (!authz?.isAuthzV2Enabled) {
    if (typeof legacyUserHasPermission === 'function') {
      return legacyUserHasPermission([globalpermissions?.homePage?.createNewProposal]);
    }

    const legacyPermissions = userInfo?.profile?.permissions || {};
    return Boolean(legacyPermissions[globalpermissions?.homePage?.createNewProposal]);
  }

  return canAccessResource(authz, {
    type: 'account',
    id: accountId,
    action: 'edit',
  });
}
